import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getAllUserForRM } from "../../redux/user/userSlice";
import toast from "react-hot-toast";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import SearchIcon from "@mui/icons-material/Search";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AppLoader from "../../components/AppLoader/AppLoader";
import {
  Autocomplete,
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputAdornment,
  Pagination,
  Paper,
  Stack,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import { colors } from "../../constants/colors";
import { investmentReports } from "../../redux/Reports/reportsSlice";

interface User {
  userId: number;
  firstName: string;
  lastName: string;
  userName: string;
  email: string;
  mobile: string;
  logInBy: number;
  onboardStatus: number;
  createdAt: string;
  aumUserId: string;
}

const ITEMS_PER_PAGE = 10;

const investmentTableConfig: { label: string; key: string }[] = [
  // { label: "Investor Name", key: "userName" },
  { label: "Mutual Fund", key: "mutual_fund" },
  { label: "Equity", key: "stock" },
  { label: "AIF", key: "aif" },
  { label: "PMS", key: "pms" },
  { label: "bond", key: "bond" },
  { label: "FD", key: "fd" },
  { label: "Private Equity", key: "private_stock" },
];

const mfTableConfig: { label: string; key: string }[] = [
  // { label: "Investor Name", key: "userName" },
  { label: "Equity", key: "EQUITY" },
  { label: "Debt", key: "DEBT" },
  { label: "Hybrid", key: "HYBRID" },
  { label: "ELSS", key: "ELSS" },
];

const InvestmentReport = () => {
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [investorGroup, setInvestorGroup] = useState("");
  const [selectedInvestor, setSelectedInvestor] = useState<any>(0);
  const [openModal, setOpenModal] = useState(false);
  const [selectedContact, setSelectedContact] = useState<{
    email: string;
    contact: string;
  } | null>(null);
  const [showReport, setShowReport] = useState(false);
  const [checkedRows, setCheckedRows] = useState<number[]>([]);
  const userType = localStorage?.getItem("userType");
  const [users, setUsers] = useState<User[]>([]);
  const dispatch = useDispatch<any>();
  const [searchInvestor, setSearchInvestor] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<any[]>([]);
  const [data, setData] = useState<any>([]);
  const [tableData, setTableData] = useState<any>([]);
  const [tabValue, setTabValue] = useState(0);
  const [tableConfig, setTableConfig] = useState<any>(investmentTableConfig);

  useEffect(() => {
    if (searchQuery) {
      const filteredData = data.filter((row: any) =>
        row.schemeName.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setTableData(filteredData);
    } else {
      setTableData(data);
    }
  }, [searchQuery]);

  useEffect(() => {
    if (tabValue === 0) {
      setTableConfig(investmentTableConfig);
    } else {
      setTableConfig(mfTableConfig);
    }
  }, [tabValue]);

  const handleCheck = (rowId: number) => {
    setCheckedRows((prev) =>
      prev.includes(rowId)
        ? prev?.filter((id) => id !== rowId)
        : [...prev, rowId]
    );
  };

  const handleOpenModal = (contact: string, email: string) => {
    setSelectedContact({ contact, email });
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedContact(null);
  };

  const handlePageChange = (_: any, value: number) => {
    setPage(value);
  };

  const paginatedData = tableData.slice(
    (page - 1) * ITEMS_PER_PAGE,
    page * ITEMS_PER_PAGE
  );

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    setIsLoading(true);
    try {
      const response = await dispatch(
        getAllUserForRM({
          pageIndex: 1,
          pageSize: 1000,
          forRm: userType === "2" ? 1 : userType === "6" ? 0 : -1,
          sortBy: 4,
          onboardStatus: -1,
          startDate: "",
          endDate: "",
          search: "",
        })
      );
      const userData = response.payload.data || [];
      setUsers(userData);
      // Update options whenever users data changes
      setOptions([
        { label: "All Investor", value: 0 },
        ...userData.map((user: any) => {
          return {
            label: `${user.firstName}`,
            value: user.userId,
          };
        }),
      ]);
    } catch (error) {
      console.error("Error fetching user data:", error);
      toast.error("Error fetching user data");
    } finally {
      setIsLoading(false);
    }
  };

  const handleGenerateReport = async () => {
    setIsLoading(true);
    try {
      const response = await dispatch(
        investmentReports({
          forRm: userType === "2" ? 1 : userType === "6" ? 0 : -1,
          pageSize: 100,
          pageIndex: 1,
          rmId: localStorage?.getItem("ID"),
          userIds:
            selectedInvestor === 0 || !selectedInvestor
              ? []
              : [selectedInvestor],
          search: "",
        })
      );
      // setTableConfig(assetClassTableConfig[assetClass]);

      const resData =
        response.payload.data?.data?.map((item: any, index: number) => {
          item.id = index + 1;
          return item;
        }) || [];
      console.log(resData);
      setData(resData);
      setTableData(resData);
    } catch (error) {
      console.error("Error fetching user data:", error);
      toast.error("Error fetching report data");
    } finally {
      setIsLoading(false);
      setShowReport(true);
    }
  };

  const generatePDF = (data: any[]) => {
    const doc = new jsPDF({
      orientation: "landscape", // default is 'portrait'
    });

    if (data.length === 0) {
      doc.text("No data available", 10, 10);
      doc.save(`investment_report.pdf`);
      return;
    }

    // Get columns from keys (you can customize)
    const columns = Object.keys(data[0]).map((key) => ({
      header: key,
      dataKey: key,
    }));

    autoTable(doc, {
      columns,
      body: data,
      styles: {
        fontSize: 7,
        cellPadding: 1,
      },
      headStyles: {
        fillColor: [22, 160, 133],
        fontSize: 8,
      },
    });

    doc.save(`investment_report.pdf`);
  };

  const generateExcel = (data: any[]) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, `investment_report.xlsx`);
  };

  const handleDownload = (fileType: string) => {
    const updatedTable =
      tabValue === 0
        ? tableData.map((row: any) => {
            return {
              ...row,
              bond: `Invested: ${row.bond.investedAmount} | Current: ${row.bond.currentValue}`,
              mutual_fund: `Invested: ${row.mutual_fund.investedAmount} | Current: ${row.mutual_fund.currentValue}`,
              fd: `Invested: ${row.fd.investedAmount} | Current: ${row.fd.currentValue}`,
              stock: `Invested: ${row.stock.investedAmount} | Current: ${row.stock.currentValue}`,
              aif: `Invested: ${row.aif.investedAmount} | Current: ${row.aif.currentValue}`,
              pms: `Invested: ${row.pms.investedAmount} | Current: ${row.pms.currentValue}`,
              ppf: `Invested: ${row.ppf.investedAmount} | Current: ${row.ppf.currentValue}`,
              private_stock: `Invested: ${row.private_stock.investedAmount} | Current: ${row.private_stock.currentValue}`,
              nps: `Invested: ${row.nps.investedAmount} | Current: ${row.nps.currentValue}`,
            };
          })
        : tableData.map((row: any) => {
            return {
              userName: row?.userName,
              equity: `Invested: ${row?.EQUITY?.investedAmount || 0} | Current: ${row?.EQUITY?.currentValue || 0}`,
              debt: `Invested: ${row?.DEBT?.investedAmount || 0} | Current: ${row?.DEBT?.currentValue || 0}`,
              hybrid: `Invested: ${row?.HYBRID?.investedAmount || 0} | Current: ${row?.HYBRID?.currentValue || 0}`,
              elss: `Invested: ${row?.ELSS?.investedAmount || 0} | Current: ${row?.ELSS?.currentValue || 0}`,
            };
          });
    if (checkedRows.length === updatedTable.length) {
      return fileType === "pdf"
        ? generatePDF(updatedTable)
        : generateExcel(updatedTable);
    }
    const selectedData = updatedTable.filter((row: any) =>
      checkedRows.includes(row.id)
    );
    fileType === "pdf"
      ? generatePDF(selectedData)
      : generateExcel(selectedData);
  };

  return (
    <>
      <AppLoader loading={isLoading} />
      <div className="py-8 px-4 sm:px-6 min-h-screen bg-lightBg">
        <div className="max-w-screen-2xl mx-auto">
          <Box
            mb={2}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h3 className="text-3xl font-bold text-primary font-nunito">
              Investment Reports
            </h3>
            <Tabs
              value={tabValue}
              onChange={(event, newValue) => setTabValue(newValue)}
              variant="standard"
              scrollButtons={false}
              TabIndicatorProps={{ style: { display: "none" } }} // removes underline
              sx={{
                backgroundColor: "#f5f5f5", // light background for the whole tab bar
                borderRadius: "8px",
                px: 1,
              }}
            >
              <Tab
                label="Investment Report"
                value={0}
                sx={{
                  backgroundColor: tabValue === 0 ? colors.primary : "#e3f2fd", // active blue, inactive light blue
                  color: colors.primary,
                  "&.Mui-selected": {
                    color: "white",
                  },
                  fontWeight: 500,
                  borderRadius: "6px",
                  mx: 1,
                  textTransform: "none",
                }}
              />
              <Tab
                label="Mutual Fund Report"
                value={1}
                sx={{
                  backgroundColor: tabValue === 1 ? colors.primary : "#e3f2fd",
                  color: colors.primary,
                  "&.Mui-selected": {
                    color: "white",
                  },
                  fontWeight: 500,
                  borderRadius: "6px",
                  mx: 1,
                  textTransform: "none",
                }}
              />
            </Tabs>
          </Box>

          <Card
            className="mb-6 rounded-xl py-4"
            sx={{ boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)" }}
          >
            <CardContent>
              <Box
                display="flex"
                flexDirection={{ xs: "column", md: "row" }}
                alignItems="flex-end"
                gap={3}
              >
                {/* Investor Name */}
                <FormControl sx={{ width: "100%", maxWidth: "400px" }}>
                  <Autocomplete
                    freeSolo
                    disableClearable
                    options={users.map((user) => ({
                      label: user.firstName + " (" + user.aumUserId + ")",
                      value: user.userId,
                    }))}
                    filterOptions={(options, state) => {
                      const inputValue = state.inputValue.toLowerCase();
                      const filtered = options.filter((option) =>
                        option.label.toLowerCase().includes(inputValue)
                      );

                      const allInvestor = { label: "All Investor", value: 0 };
                      const includeAllInvestor =
                        inputValue === "" ||
                        "all investor".includes(inputValue);
                      return includeAllInvestor
                        ? [allInvestor, ...filtered]
                        : filtered;
                    }}
                    inputValue={searchInvestor}
                    onInputChange={(_, newInputValue, reason) => {
                      if (reason !== "reset") {
                        setSearchInvestor(newInputValue);
                      }
                    }}
                    getOptionLabel={(option: any) =>
                      typeof option === "string" ? option : option?.label || ""
                    }
                    isOptionEqualToValue={(option, value) =>
                      typeof value === "string"
                        ? option.label === value
                        : option.value === value.value
                    }
                    value={
                      typeof selectedInvestor === "string"
                        ? selectedInvestor
                        : users
                            .map((user) => ({
                              label:
                                user.firstName + " (" + user.aumUserId + ")",
                              value: user.userId,
                            }))
                            .find((opt) => opt.value === selectedInvestor) || {
                            label: "All Investor",
                            value: 0,
                          }
                    }
                    onChange={(_, newValue: any) => {
                      if (typeof newValue === "string") {
                        setSelectedInvestor(newValue);
                        setSearchInvestor(newValue);
                      } else if (newValue) {
                        setSelectedInvestor(newValue.value);
                        setSearchInvestor(newValue.label);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Investor Name"
                        variant="outlined"
                      />
                    )}
                    renderOption={(props, option) => (
                      <li {...props} key={option.value}>
                        {option.label}
                      </li>
                    )}
                  />
                </FormControl>

                {/* Generate Button */}
                <Box minWidth={{ xs: "100%", md: "160px" }}>
                  <Button
                    fullWidth
                    variant="contained"
                    sx={{
                      height: "56px",
                      backgroundColor: colors.primary,
                      textTransform: "none",
                      fontWeight: "bold",
                    }}
                    disabled={!selectedInvestor && selectedInvestor !== 0}
                    onClick={handleGenerateReport}
                  >
                    Generate
                  </Button>
                </Box>
              </Box>
            </CardContent>
          </Card>

          {showReport && (
            <>
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={2}
                alignItems="center"
                justifyContent="space-between"
                className="mb-4"
                flexWrap="wrap"
              >
                {/* Search Field */}
                <TextField
                  variant="outlined"
                  placeholder="Search by Scheme Name"
                  value={searchQuery}
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                    setPage(1);
                  }}
                  sx={{
                    minWidth: { xs: "100%", sm: "300px" },
                    maxWidth: "400px",
                    flexGrow: 1,
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon fontSize="small" />
                      </InputAdornment>
                    ),
                    sx: {
                      height: "40px",
                      fontSize: "14px",
                      px: 1,
                    },
                  }}
                  inputProps={{
                    style: {
                      padding: "0 8px",
                      height: "40px",
                    },
                  }}
                />

                {/* Download Buttons */}
                <Stack direction="row" spacing={1} flexWrap="wrap">
                  <Button
                    variant="outlined"
                    color="success"
                    sx={{
                      height: "40px",
                      fontSize: "14px",
                      textTransform: "none",
                      whiteSpace: "nowrap",
                    }}
                    onClick={() => handleDownload("pdf")}
                    disabled={checkedRows.length === 0}
                  >
                    Download PDF
                  </Button>

                  <Button
                    variant="outlined"
                    color="info"
                    sx={{
                      height: "40px",
                      fontSize: "14px",
                      textTransform: "none",
                      whiteSpace: "nowrap",
                    }}
                    onClick={() => handleDownload("excel")}
                    disabled={checkedRows.length === 0}
                  >
                    Download Excel
                  </Button>
                </Stack>
              </Stack>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                  margin: "auto",
                }}
              >
                <TableContainer
                  component={Paper}
                  style={{ width: "100%" }}
                  sx={{ boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)" }}
                >
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          style={{
                            fontWeight: "bold",
                            minWidth: 80,
                            textAlign: "center",
                          }}
                        >
                          <Checkbox
                            size="small"
                            indeterminate={
                              checkedRows.length > 0 &&
                              checkedRows.length < tableData.length
                            }
                            checked={
                              tableData.length > 0 &&
                              checkedRows.length === tableData.length
                            }
                            onChange={(e) => {
                              if (e.target.checked) {
                                setCheckedRows(
                                  tableData.map((row: any) => row.id)
                                );
                              } else {
                                setCheckedRows([]);
                              }
                            }}
                          />
                        </TableCell>
                        <TableCell
                          style={{
                            fontWeight: "bold",
                            minWidth: 140,
                            textAlign: "center",
                          }}
                        >
                          Investor Name
                        </TableCell>
                        {tableConfig?.map((col: any, idx: number) => (
                          <TableCell
                            key={idx}
                            style={{
                              fontWeight: "bold",
                              minWidth: 140,
                              textAlign: "center",
                            }}
                          >
                            {col.label}
                          </TableCell>
                        ))}

                        <TableCell
                          style={{ fontWeight: "bold", textAlign: "center" }}
                        >
                          Contact
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {paginatedData &&
                        paginatedData?.map((row: any, index: number) => (
                          <TableRow key={index}>
                            <TableCell style={{ textAlign: "center" }}>
                              <Checkbox
                                size="small"
                                checked={checkedRows.includes(row?.id)}
                                onChange={() => handleCheck(row?.id)}
                              />
                            </TableCell>
                            <TableCell style={{ textAlign: "center" }}>
                              {row["userName"] ?? "-"}
                            </TableCell>
                            {tableConfig?.map((col: any, idx: number) => (
                              <TableCell
                                key={idx}
                                style={{ textAlign: "center" }}
                              >
                                {row[col.key] &&
                                (row[col.key]?.investedAmount > 0 ||
                                  row[col.key]?.currentValue > 0) ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                    }}
                                  >
                                    {row[col.key]?.investedAmount > 0 && (
                                      <span
                                        style={{
                                          fontWeight: 500,
                                          color: "#555",
                                        }}
                                      >
                                        ₹
                                        {row[
                                          col.key
                                        ]?.investedAmount?.toLocaleString()}
                                        <span
                                          style={{
                                            fontSize: "12px",
                                            color: "#888",
                                            marginLeft: "4px",
                                          }}
                                        >
                                          (Invested)
                                        </span>
                                      </span>
                                    )}
                                    {row[col.key]?.currentValue > 0 && (
                                      <span
                                        style={{
                                          fontWeight: 500,
                                          color: "#2e7d32",
                                        }}
                                      >
                                        ₹
                                        {row[
                                          col.key
                                        ]?.currentValue?.toLocaleString()}
                                        <span
                                          style={{
                                            fontSize: "12px",
                                            color: "#888",
                                            marginLeft: "4px",
                                          }}
                                        >
                                          (Current)
                                        </span>
                                      </span>
                                    )}
                                  </div>
                                ) : (
                                  "-"
                                )}
                              </TableCell>
                            ))}

                            <TableCell style={{ textAlign: "center" }}>
                              <Button
                                onClick={() =>
                                  handleOpenModal(row.mobile, row.email)
                                }
                                startIcon={
                                  <AccountCircleIcon
                                    style={{
                                      fontSize: "24px",
                                      color: colors.primary,
                                    }}
                                  />
                                }
                                variant="text"
                                sx={{ minWidth: 0 }}
                              />
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>

              <Box mt={4} display="flex" justifyContent="center">
                <Pagination
                  count={Math.ceil(tableData.length / ITEMS_PER_PAGE)}
                  page={page}
                  onChange={handlePageChange}
                  sx={{
                    "& .Mui-selected": {
                      backgroundColor: `${colors.secondary} !important`,
                      color: "#fff",
                      fontWeight: "bold",
                    },
                  }}
                />
              </Box>
            </>
          )}
        </div>
      </div>
      <Dialog open={openModal} onClose={handleCloseModal}>
        <DialogTitle>Investor Contact Details</DialogTitle>
        <DialogContent dividers>
          <Typography>
            <strong>Contact Number:</strong> {selectedContact?.contact}
          </Typography>
          <Typography sx={{ mt: 1 }}>
            <strong>Email:</strong> {selectedContact?.email}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default InvestmentReport;
